export default __webpack_public_path__ + "static/media/more_info_brake_good.42129cfc.png";